import axios from 'axios';
import { REST_API } from '../constants/defaultValues';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: REST_API
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
